import script from "./Uploads.vue?vue&type=script&setup=true&lang=js"
export * from "./Uploads.vue?vue&type=script&setup=true&lang=js"

import "./Uploads.vue?vue&type=style&index=0&id=7f645dc5&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f645dc5"]])

export default __exports__